import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './navbar.css'
import MattCornicDev from '../../media/Matt-Cornic-Dev.svg'
import { logoMattCornic } from '../../content-option'

function Navbar() {
    return (
        <>
            <div className='navBarContainer'>
                <div>
                    <Link className="navbar-brand nav_ac" to="/">{logoMattCornic}

                    </Link>
                </div>
                <div>
                    <h1>COURS FORMATIONS DEVELOPPEUR D'APPLICATIONS</h1>
                </div>
            </div>
        </>
    )
}
export default Navbar
